import {Button, Dropdown} from 'antd';
import {ButtonProps} from 'antd/es/button';
import cn from 'classnames';
import React, {ReactElement, FC} from 'react';

import {IconsMap} from 'components/dynamic-icon';

import './kebab-menu.less';

interface IKebabMenuProps {
    children: ReactElement;
    button?: ButtonProps;
    placeholder?: ReactElement;
    overlayClassName?: string;
}

export const KebabMenu: FC<IKebabMenuProps> = ({
    children,
    button,
    placeholder,
    overlayClassName,
}: IKebabMenuProps) => {
    const {className, ...restButtonProps} = button ?? {};

    return (
        <Dropdown
            overlay={() => {
                if (placeholder) {
                    return (
                        <div className="kebab-menu__placeholder">
                            {placeholder}
                        </div>
                    );
                }

                return children;
            }}
            className="kebab-menu"
            overlayClassName={overlayClassName}
            forceRender={false}
        >
            <Button
                type="default"
                className={cn('kebab-menu__button', 'btn-only-icon', className)}
                {...restButtonProps}
            >
                <IconsMap.MoreIcon />
            </Button>
        </Dropdown>
    );
};
